import { c as _c } from "react/compiler-runtime";
import { FieldController } from '@module/mdrt-org/shared/components/field-controller/field-controller';
import { MAX_JOB_TITLE_LENGTH, MAX_PERSONAL_COMPANY_NAME_LENGTH, SOCIAL_MEDIA_LINK_LENGTH } from '@module/mdrt-org/shared/utils/constants/inputs-constants';
import { FormInput } from '@shared/ui-components/form-input/form-input';
import { SocialPlatform, validateSocialLink } from '@shared/utils/helpers/social-link-validators';
import styles from '@module/mdrt-org/dashboard/dashboard-page-content/components/pdf-modal-wrapper/press-release-pdf-modal/press-release-pdf-modal.module.scss';
type ProfessionalInformationSectionProps = {
  cmsContent: {
    company: string;
    facebookLabel: string;
    instagramLabel: string;
    jobTitle: string;
    linkedInLabel: string;
    linkInputValidationLabel: string;
    personalCompany: string;
    professionalInformationSectionTitle: string;
    requiredLabel: string;
    twitterXLabel: string;
  };
  containerClass: string;
  setActiveField: (field: string) => void;
};
export const ProfessionalInformationSection = t0 => {
  const $ = _c(69);
  const {
    cmsContent,
    containerClass,
    setActiveField
  } = t0;
  let t1;
  if ($[0] !== cmsContent.professionalInformationSectionTitle) {
    t1 = <h2 className={styles["section-title"]}>{cmsContent.professionalInformationSectionTitle}</h2>;
    $[0] = cmsContent.professionalInformationSectionTitle;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const t2 = styles[`${containerClass}__professional-information-block-inputs`];
  let t3;
  if ($[2] !== setActiveField) {
    t3 = <FormInput onFocus={() => setActiveField("JobTitle")} />;
    $[2] = setActiveField;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== cmsContent.jobTitle || $[5] !== t3) {
    t4 = <FieldController label={cmsContent.jobTitle} maxLength={MAX_JOB_TITLE_LENGTH} name="jobTitle">{t3}</FieldController>;
    $[4] = cmsContent.jobTitle;
    $[5] = t3;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== setActiveField) {
    t5 = <FormInput onFocus={() => setActiveField("CompanyName")} />;
    $[7] = setActiveField;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== cmsContent.personalCompany || $[10] !== t5) {
    t6 = <FieldController label={cmsContent.personalCompany} maxLength={MAX_PERSONAL_COMPANY_NAME_LENGTH} name="personalCompany">{t5}</FieldController>;
    $[9] = cmsContent.personalCompany;
    $[10] = t5;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== setActiveField) {
    t7 = <FormInput onFocus={() => setActiveField("CompanyName")} />;
    $[12] = setActiveField;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== cmsContent.company || $[15] !== t7) {
    t8 = <FieldController label={cmsContent.company} maxLength={MAX_PERSONAL_COMPANY_NAME_LENGTH} name="companyName">{t7}</FieldController>;
    $[14] = cmsContent.company;
    $[15] = t7;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  const t9 = cmsContent.linkedInLabel;
  let t10;
  if ($[17] !== cmsContent.linkInputValidationLabel) {
    t10 = validateSocialLink(SocialPlatform.LinkedIn, cmsContent.linkInputValidationLabel);
    $[17] = cmsContent.linkInputValidationLabel;
    $[18] = t10;
  } else {
    t10 = $[18];
  }
  let t11;
  if ($[19] !== t10) {
    t11 = {
      validate: t10
    };
    $[19] = t10;
    $[20] = t11;
  } else {
    t11 = $[20];
  }
  let t12;
  if ($[21] !== setActiveField) {
    t12 = <FormInput onFocus={() => setActiveField("LinkedInLabel")} />;
    $[21] = setActiveField;
    $[22] = t12;
  } else {
    t12 = $[22];
  }
  let t13;
  if ($[23] !== cmsContent.linkedInLabel || $[24] !== t11 || $[25] !== t12) {
    t13 = <FieldController label={t9} maxLength={SOCIAL_MEDIA_LINK_LENGTH} name="linkedIn" rules={t11}>{t12}</FieldController>;
    $[23] = cmsContent.linkedInLabel;
    $[24] = t11;
    $[25] = t12;
    $[26] = t13;
  } else {
    t13 = $[26];
  }
  const t14 = cmsContent.facebookLabel;
  let t15;
  if ($[27] !== cmsContent.linkInputValidationLabel) {
    t15 = validateSocialLink(SocialPlatform.Facebook, cmsContent.linkInputValidationLabel);
    $[27] = cmsContent.linkInputValidationLabel;
    $[28] = t15;
  } else {
    t15 = $[28];
  }
  let t16;
  if ($[29] !== t15) {
    t16 = {
      validate: t15
    };
    $[29] = t15;
    $[30] = t16;
  } else {
    t16 = $[30];
  }
  let t17;
  if ($[31] !== setActiveField) {
    t17 = <FormInput onFocus={() => setActiveField("FacebookLabel")} />;
    $[31] = setActiveField;
    $[32] = t17;
  } else {
    t17 = $[32];
  }
  let t18;
  if ($[33] !== cmsContent.facebookLabel || $[34] !== t16 || $[35] !== t17) {
    t18 = <FieldController label={t14} maxLength={SOCIAL_MEDIA_LINK_LENGTH} name="facebook" rules={t16}>{t17}</FieldController>;
    $[33] = cmsContent.facebookLabel;
    $[34] = t16;
    $[35] = t17;
    $[36] = t18;
  } else {
    t18 = $[36];
  }
  const t19 = cmsContent.instagramLabel;
  let t20;
  if ($[37] !== cmsContent.linkInputValidationLabel) {
    t20 = validateSocialLink(SocialPlatform.Instagram, cmsContent.linkInputValidationLabel);
    $[37] = cmsContent.linkInputValidationLabel;
    $[38] = t20;
  } else {
    t20 = $[38];
  }
  let t21;
  if ($[39] !== t20) {
    t21 = {
      validate: t20
    };
    $[39] = t20;
    $[40] = t21;
  } else {
    t21 = $[40];
  }
  let t22;
  if ($[41] !== setActiveField) {
    t22 = <FormInput onFocus={() => setActiveField("InstagramLabel")} />;
    $[41] = setActiveField;
    $[42] = t22;
  } else {
    t22 = $[42];
  }
  let t23;
  if ($[43] !== cmsContent.instagramLabel || $[44] !== t21 || $[45] !== t22) {
    t23 = <FieldController label={t19} maxLength={SOCIAL_MEDIA_LINK_LENGTH} name="instagram" rules={t21}>{t22}</FieldController>;
    $[43] = cmsContent.instagramLabel;
    $[44] = t21;
    $[45] = t22;
    $[46] = t23;
  } else {
    t23 = $[46];
  }
  const t24 = cmsContent.twitterXLabel;
  let t25;
  if ($[47] !== cmsContent.linkInputValidationLabel) {
    t25 = validateSocialLink(SocialPlatform.Twitter, cmsContent.linkInputValidationLabel);
    $[47] = cmsContent.linkInputValidationLabel;
    $[48] = t25;
  } else {
    t25 = $[48];
  }
  let t26;
  if ($[49] !== t25) {
    t26 = {
      validate: t25
    };
    $[49] = t25;
    $[50] = t26;
  } else {
    t26 = $[50];
  }
  let t27;
  if ($[51] !== setActiveField) {
    t27 = <FormInput onFocus={() => setActiveField("TwitterXLabel")} />;
    $[51] = setActiveField;
    $[52] = t27;
  } else {
    t27 = $[52];
  }
  let t28;
  if ($[53] !== cmsContent.twitterXLabel || $[54] !== t26 || $[55] !== t27) {
    t28 = <FieldController label={t24} maxLength={SOCIAL_MEDIA_LINK_LENGTH} name="twitterX" rules={t26}>{t27}</FieldController>;
    $[53] = cmsContent.twitterXLabel;
    $[54] = t26;
    $[55] = t27;
    $[56] = t28;
  } else {
    t28 = $[56];
  }
  let t29;
  if ($[57] !== t13 || $[58] !== t18 || $[59] !== t2 || $[60] !== t23 || $[61] !== t28 || $[62] !== t4 || $[63] !== t6 || $[64] !== t8) {
    t29 = <div className={t2}>{t4}{t6}{t8}{t13}{t18}{t23}{t28}</div>;
    $[57] = t13;
    $[58] = t18;
    $[59] = t2;
    $[60] = t23;
    $[61] = t28;
    $[62] = t4;
    $[63] = t6;
    $[64] = t8;
    $[65] = t29;
  } else {
    t29 = $[65];
  }
  let t30;
  if ($[66] !== t1 || $[67] !== t29) {
    t30 = <section>{t1}{t29}</section>;
    $[66] = t1;
    $[67] = t29;
    $[68] = t30;
  } else {
    t30 = $[68];
  }
  return t30;
};